/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaWithScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/media-with-scrollable-text/base-media-with-scrollable-text.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {ScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/scrollable-text/scrollable-text.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullMediaWithScrollableTextFragment = gql`
  ${BaseMediaWithScrollableTextFragment}
  ${ImageFragment}
  ${ScrollableTextFragment}
  ${VideoFragment}

  fragment FullMediaWithScrollableTextFragment on MediaWithScrollableText {
    ...BaseMediaWithScrollableTextFragment

    backgroundMedia {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
    backgroundMediaMobile {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
    scrollableTextCollection {
      items {
        __typename
        ... on ScrollableText {
          ...ScrollableTextFragment
        }
      }
    }
    scrollableTextCursorCollection {
      items {
        __typename
        ... on ScrollableText {
          ...ScrollableTextFragment
        }
      }
    }
  }
`;
